import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from '../config/config.service';
import { LegacyReplayTemplate } from '../../models/simulator.models';

/**
 * Service for managing Legacy Replay Templates
 */
@Injectable({
  providedIn: 'root',
})
export class LegacyReplayTemplateService {
  private simulatorBasePath: string;

  constructor(private http: HttpClient, private configService: ConfigService) {
    this.simulatorBasePath =
      this.configService.config?.simulatorBasePath || '';
  }

  /**
   * Get all Legacy Replay templates
   */
  getAllTemplates(): Observable<LegacyReplayTemplate[]> {
    return this.http.get<LegacyReplayTemplate[]>(
      `${this.simulatorBasePath}/api/simulations/legacy-replay-templates`
    );
  }

  /**
   * Get only active Legacy Replay templates (for dropdown)
   */
  getActiveTemplates(): Observable<LegacyReplayTemplate[]> {
    return this.http.get<LegacyReplayTemplate[]>(
      `${this.simulatorBasePath}/api/simulations/legacy-replay-templates/active`
    );
  }

  /**
   * Get a single template by ID
   */
  getTemplateById(id: string): Observable<LegacyReplayTemplate> {
    return this.http.get<LegacyReplayTemplate>(
      `${this.simulatorBasePath}/api/simulations/legacy-replay-templates/${id}`
    );
  }

  /**
   * Get Tournament ID from a legacy database
   * Each legacy database contains exactly one tournament
   */
  getTournamentId(request: {
    legacyServer: string;
    legacyDatabase: string;
    legacyUserId: string;
    legacyPassword: string;
  }): Observable<{ tournamentId: string }> {
    return this.http.post<{ tournamentId: string }>(
      `${this.simulatorBasePath}/api/legacy-replay/tournament-id`,
      request
    );
  }
}
